const SLICE_NAME = 'agentModeSlice';

/**
 * HITL-1604: the one global mode that says what the supervising agent is allowed
 * to do while the AI runs the order.
 *
 * `Supervise` and `Shadow` are both **silent** — nothing the agent does in them
 * reaches the customer or the POS. `Intercept` is the only mode that can speak
 * or send, and it is what today's "agent has taken over" state becomes.
 *
 * Deliberately NOT a rename of `isAIAutoMode`, and nothing in this feature
 * writes to it: mutating that flag to fix a display symptom caused a production
 * incident (dropped orders + a cart revert).
 */
enum AgentMode {
  supervise = 'Supervise',
  shadow = 'Shadow',
  intercept = 'Intercept',
}

/** Every HITL session starts here. There is no persistence — see the slice. */
const DEFAULT_AGENT_MODE = AgentMode.supervise;

export { SLICE_NAME, AgentMode, DEFAULT_AGENT_MODE };
